import React from 'react';
import { TypographyProps } from './interface';
import MuiTypography, { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';
import { designTokenToColor } from '@src/utils/colors';
import { DesignTokenColor, palette } from '@src/theme/medelyPalette';
import { getCalculatedTypographyProps } from './utils';

/**
 * @deprecated Use Heading, Label, or Text instead
 */
export const Typography = (props: TypographyProps) => {
  const { component, fontWeight, fontSize, lineHeight, sx } = medelyPropsToMuiProps(props);
  return (
    <MuiTypography
      component={props.htmlElement ?? component!}
      fontWeight={fontWeight}
      fontSize={fontSize}
      lineHeight={lineHeight}
      textAlign={props.textAlign}
      sx={sx}
      data-testid={props['data-testid']}
    >
      {props.children}
    </MuiTypography>
  );
};

const medelyPropsToMuiProps = (props: TypographyProps): MuiTypographyProps => {
  const { variant = 'body', size = 'm', color = 'text.primary' } = props;
  const muiProps: MuiTypographyProps = {};
  assignWeightSizeAndComponent(muiProps, variant, size);
  assignColor(muiProps, color);

  return muiProps;
};

const assignWeightSizeAndComponent = (
  muiProps: MuiTypographyProps,
  variant: TypographyProps['variant'],
  size: TypographyProps['size'],
) => {
  const { component, fontSize, fontWeight, lineHeight } = getCalculatedTypographyProps(
    variant,
    size,
  );
  muiProps['component'] = component;
  muiProps['fontWeight'] = fontWeight;
  muiProps['fontSize'] = fontSize;
  muiProps['lineHeight'] = `${lineHeight}px`;
};

const assignColor = (muiProps: MuiTypographyProps, colorToken?: DesignTokenColor) => {
  const color = colorToken ? designTokenToColor(colorToken) : palette.text.primary;
  muiProps.sx = { ...muiProps.sx, color };
};
